// @flow
import { push } from 'react-router-redux';

export const HUD_TOGGLE = 'hud/TOGGLE';
export const HUD_SET_STEP = 'hud/CHANGE_STEP';
export const HUD_SET_TOUR_IN_PROGRESS = 'hud/SET_TOUR_IN_PROGRESS';

export function toggleHUD(open) {
  return (dispatch, getState) => {
    if (open) {
      const {
        map: { selectedFeature },
      } = getState();

      if (selectedFeature && selectedFeature.type !== 's') {
        dispatch(push('/'));
      }
    }

    dispatch({
      type: HUD_TOGGLE,
      open,
    });
  };
}

export function setHUDStep(step) {
  return {
    type: HUD_SET_STEP,
    step,
  };
}

export function setHUDTourInProgress(hudTourInProgress) {
  return {
    type: HUD_SET_TOUR_IN_PROGRESS,
    hudTourInProgress,
  };
}



// WEBPACK FOOTER //
// ./actions/hud.js